<script setup lang="ts">
import { computed } from "vue";
import Icon from "./Icon.vue";
import { localized, t } from "../i18n";

/**
 * The conversation header's tag button, as WhatsApp Web's "Add to list": without tags it offers to
 * add one; with tags it shows the first one's colour and name, and how many more.
 */
const props = defineProps<{
  tags: Array<{
    id: string;
    name: Record<string, string> | string;
    color: string | null;
  }>;
  /** Text-free, for a narrow header. */
  compact?: boolean;
}>();
const emit = defineEmits<{ open: [event: MouseEvent] }>();

const first = computed(() => props.tags[0] ?? null);
const label = computed(() =>
  first.value ? localized(first.value.name) : t("tags.add"),
);
const summary = computed(() =>
  props.tags.length
    ? t("tags.pill.label", {
        names: props.tags.map((x) => localized(x.name)).join(", "),
      })
    : t("tags.add"),
);
</script>
<template>
  <button
    type="button"
    class="tag-pill"
    :class="{ compact, empty: !first }"
    :aria-label="summary"
    :title="summary"
    aria-haspopup="menu"
    @click="emit('open', $event)"
  >
    <i
      v-if="first"
      class="tag-pill-dot"
      :style="first.color ? { '--tag': first.color } : undefined"
    /><Icon v-else name="wa-lists" :size="24" /><span
      v-if="!compact"
      class="tag-pill-label truncate"
      >{{ label }}</span
    ><span v-if="tags.length > 1" class="tag-pill-more"
      >+{{ tags.length - 1 }}</span
    ><Icon name="wa-drop-down" :size="20" class="tag-pill-caret" />
  </button>
</template>
